import type { UnicoCaptureResult } from '../hooks/unico-context';

export type ProxyDispatchStatus = 'pending' | 'sent' | 'failed' | 'skipped_expired';

export type ProxyReadyPayload = {
  process_id: string;
  provider: 'unico';
  capture_type: 'selfie_liveness';
  encrypted: string;
  metadata: UnicoCaptureResult['metadata'];
  token: UnicoCaptureResult['token'];
  integrations: {
    serpro: { score_result: null; face_match_result: null; base_consulted: null; similarity_value: null };
    salesforce: { score_result: null; face_match_result: null; base_consulted: null; similarity_value: null };
  };
};

export const buildProxyReadyPayload = (capture: UnicoCaptureResult): ProxyReadyPayload => ({
  process_id: capture.process_id,
  provider: capture.provider,
  capture_type: capture.capture_type,
  encrypted: capture.encrypted,
  metadata: capture.metadata,
  token: capture.token,
  integrations: {
    serpro: { score_result: null, face_match_result: null, base_consulted: null, similarity_value: null },
    salesforce: { score_result: null, face_match_result: null, base_consulted: null, similarity_value: null },
  },
});

// Simulação para a tela de teste — no fluxo real de assinatura será substituído por sendSelfie({ token, encrypted })
export const dispatchProxyPayload = async (
  payload: ProxyReadyPayload,
): Promise<{ status: ProxyDispatchStatus; dispatched_at: string | null }> => {
  const now = Date.now();
  const expiresAt = new Date(payload.token.expires_at).getTime();
  if (now >= expiresAt) return { status: 'skipped_expired', dispatched_at: null };
  await new Promise((r) => setTimeout(r, 120));
  return { status: 'sent', dispatched_at: new Date().toISOString() };
};
